// Button component is not contentful component
// Has background

import PropTypes from 'prop-types';

import { getButtonClass } from './Button.constants';

function Button({ children = null, invert = false, style = '', onClick, role = 'button', type = 'primary', tabIndex }) {
  const buttonClass = getButtonClass({
    type,
    invert,
    style,
  });
  return (
    <button
      className={buttonClass}
      onClick={onClick}
      role={role}
      tabIndex={tabIndex}
    >
      {children}
    </button>
  );
}

Button.propTypes = {
  children: PropTypes.node,
  invert: PropTypes.bool,
  onClick: PropTypes.func,
  role: PropTypes.string,
  tabIndex: PropTypes.number,
  // button's classname
  style: PropTypes.string,
  type: PropTypes.string,
};


export default Button;
